// Location: assets/bal-header-intro.js
// What: Reveals homepage navigation when the KV opening finishes.
// Why: Keeps the full opening unobstructed while preserving active navigation.
// RELEVANT FILES: assets/bal-header-intro.css, assets/bal-kv-shelf.js, layout/theme.liquid
(() => {
  const root = document.documentElement;
  const overlay = document.querySelector('.bal-header-overlay');
  if (!root.classList.contains('bal-header-intro') || !overlay) return;
  let opening = root.dataset.balKvOpening !== 'false';
  let editorSelection = false;
  const update = () => {
    const shown = root.classList.contains('bal-header-shown');
    const engaged = shown && (overlay.contains(document.activeElement) || overlay.querySelector('details[open]'));
    const visible = !document.querySelector('[data-kv]') || !opening || editorSelection || !!engaged;
    root.classList.toggle('bal-header-shown', visible);
    overlay.inert = !visible;
    overlay.setAttribute('aria-hidden', String(!visible));
  };
  window.addEventListener('bal:kv-stage', event => {
    if (typeof event.detail?.opening !== 'boolean') return;
    opening = event.detail.opening;
    update();
  });
  window.addEventListener('pageshow', () => {
    opening = root.dataset.balKvOpening !== 'false';
    update();
  });
  document.addEventListener('focusout', () => requestAnimationFrame(update));
  document.addEventListener('toggle', update, true);
  document.addEventListener('shopify:section:select', event => {
    editorSelection = overlay.contains(event.target);
    update();
  });
  document.addEventListener('shopify:section:deselect', () => {
    editorSelection = false;
    update();
  });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(update));
  update();
})();
